"use client";

import { ApiActual } from "@/api/article";
import { useParams } from "next/navigation";
import { useLocalizedQuery } from "@/hooks/locale/useLocalizeQuery/useLocalizeQuery";

export const useDetailActualData = () => {
  const params = useParams();
  const { id } = params;
  const isIdValid = typeof id === "string" && !Number.isNaN(+id);

  const { data: detailActual, isLoading } = useLocalizedQuery({
    queryKey: [`detailActual${id}`],
    queryFn: async lang => ApiActual.getDetailActual(lang, +id),
    options: { enabled: isIdValid },
  });

  return {
    detailActual,
    isLoading,
  };
};
